import type { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { IconButton } from 'react-native-paper';

import { ArrowBackIcon, CloseIcon } from '@/assets';

const styles = StyleSheet.create({
  header: {
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    flexDirection: 'row'
  }
});

type Props = {
  canGoBack: boolean;
  onBack: () => void;
  onClose: () => void;
};

export const BackCloseHeader: FC<Props> = ({ canGoBack, onBack, onClose }) => (
  <View style={styles.header}>
    <View>
      {canGoBack && (
        <IconButton
          icon={({ color, size }) => (
            <ArrowBackIcon fill={color} width={size} height={size} />
          )}
          onPress={onBack}
        />
      )}
    </View>
    <View>
      <IconButton
        icon={({ color, size }) => (
          <CloseIcon fill={color} width={size} height={size} />
        )}
        onPress={onClose}
      />
    </View>
  </View>
);
